document.querySelectorAll('.banner--marquee').forEach((marquee) => {
  const group = marquee.querySelector('.banner--group');
  if (!group) return;

  const originalItems = Array.from(group.children);
  if (!originalItems.length) return;

  // Le gap CSS calculé en px — nécessaire pour un reset seamless
  const gap = parseFloat(getComputedStyle(group).columnGap) || 0;

  // Largeur d'une "période" = contenu + 1 gap (l'espace après le dernier item)
  const originalWidth = group.offsetWidth + gap;

  // Clone les items jusqu'à couvrir au moins 3x la largeur du marquee
  while (group.offsetWidth < marquee.offsetWidth * 3) {
    originalItems.forEach((item) => group.appendChild(item.cloneNode(true)));
  }

  const speed = .5; // px par frame (~60px/s à 60fps)
  let x = 0;
  let paused = false;
  let rafId;

  const tick = () => {
    x -= speed;
    // Reset invisible : on revient exactement au même point visuel
    if (Math.abs(x) >= originalWidth) x += originalWidth;
    group.style.transform = `translateX(${x}px)`;
    if (!paused) rafId = requestAnimationFrame(tick);
  };

  rafId = requestAnimationFrame(tick);

  marquee.addEventListener('mouseenter', () => {
    paused = true;
    cancelAnimationFrame(rafId);
  });
  marquee.addEventListener('mouseleave', () => {
    paused = false;
    rafId = requestAnimationFrame(tick);
  });
});
